import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ringtone/ring.mp3'


const _withScopeId = n => (_pushScopeId("data-v-761f1895"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", {
  id: "ringtone",
  preload: "auto",
  loop: "",
  playsinline: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: _imports_0,
    type: "audio/mpeg"
  })
], -1))
const _hoisted_2 = { class: "header-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationBlock = _resolveComponent("NotificationBlock")!
  const _component_Header = _resolveComponent("Header")!
  const _component_ActiveCall = _resolveComponent("ActiveCall")!
  const _component_IncomingCall = _resolveComponent("IncomingCall")!
  const _component_VideoCall = _resolveComponent("VideoCall")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["web-phone-shell", _ctx.webPhoneClasses])
  }, [
    _createVNode(_component_NotificationBlock),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["content", {'scrollbars': !_ctx.settings.minimize}])
    }, [
      (_ctx.callsStore.length && !_ctx.settings.maximize)
        ? (_openBlock(), _createBlock(_component_ActiveCall, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.incoming.length)
        ? (_openBlock(), _createBlock(_component_IncomingCall, { key: 1 }))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_VideoCall, null, null, 512), [
        [_vShow, _ctx.currentComponentStore === 'VideoCall']
      ]),
      (_ctx.currentComponentStore !== 'VideoCall')
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponentStore), { key: 2 }))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}